import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Crown } from 'lucide-react';

export default function DashboardHeader({ user, isVip, onAddGoal }) {
  const kompaId = `KP-2026-${(user.cedula || '00000').replace(/\D/g, '').slice(-5).padStart(5, '0')}`;

  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-center justify-between px-6 md:px-8 pt-8 md:pt-10 pb-4"
      data-testid="dashboard-header"
    >
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full overflow-hidden bg-gray-100 border-2 border-white shadow-md flex-shrink-0 flex items-center justify-center">
          {user?.avatar ? (
            <img src={user.avatar} alt="" className="w-full h-full object-cover" onError={(e) => { e.target.style.display = 'none'; }} />
          ) : (
            <span className="text-base font-bold text-[#1f2d5a]" data-testid="dashboard-avatar-fallback">
              {(user?.nombre || user?.email || 'K').trim().charAt(0).toUpperCase()}
            </span>
          )}
        </div>
        <div>
          <h2 className="text-lg font-bold text-black leading-tight" data-testid="dashboard-greeting">
            Hola, {user.nombre || user.email?.split('@')[0] || 'Kompa'}
          </h2>
          <div className="flex items-center gap-2 mt-0.5">
            <span className="text-[11px] text-gray-400 font-medium" data-testid="kompa-id">{kompaId}</span>
            {isVip ? (
              <span
                className="inline-flex items-center gap-1 text-[10px] font-black text-white uppercase tracking-wider px-2 py-0.5 rounded-full"
                style={{ background: 'linear-gradient(135deg, #fbb040 0%, #e09a20 40%, #d4900e 70%, #fbb040 100%)' }}
                data-testid="badge-vip"
              >
                <Crown className="w-3 h-3" /> KOMPA CLUB
              </span>
            ) : (
              <span className="inline-flex items-center text-[10px] font-bold text-[#1f2d5a] bg-[#1f2d5a]/10 uppercase tracking-wider px-2 py-0.5 rounded-full" data-testid="badge-standard">
                Kompa
              </span>
            )}
          </div>
        </div>
      </div>

      {onAddGoal && (
        <motion.button
          whileTap={{ scale: 0.9 }}
          onClick={onAddGoal}
          className="w-10 h-10 bg-[#fbb040] rounded-full flex items-center justify-center shadow-md hover:bg-[#ffa000] transition-colors"
          data-testid="add-goal-btn"
        >
          <Plus className="w-5 h-5 text-black" strokeWidth={2.5} />
        </motion.button>
      )}
    </motion.div>
  );
}
